import { gql, useQuery } from '@apollo/client';
import { Loader } from '@gasbuddy/react-components';
import loadable from '@loadable/component';
import React from 'react';
import { useLocation } from 'react-router';
import PageType from '../../constants/pageType';

const LPTemplate1 = loadable(() => import('../LandingPageTemplate1'));
const AboutUsTemplate = loadable(() => import('../AboutUsPage'));

export const GET_PAGE = gql`
  query($url: String!) {
    page(url: $url) {
      ... on CMSAboutUsPage {
        member {
          bio
          bioImage {
            height
            url
            width
          }
          firstName
          lastName
          link
          memberExecutiveTeam
          title
        }
        meta {
          content
          title
          description
          image {
            url
          }
          name
          provider
          title
          type
        }
        press_coverage {
          alt
          content
          image {
            height
            url
            width
          }
        }
        sections {
          cta_url
          cta_label
          description
          image {
            url
          }
          image_alt
          mobile_image {
            url
          }
          name
          title
        }
        title
        type
        url
      }
      ... on CMSLandingPage {
        actions {
          event_attributes {
            name
            value
          }
          name
          tag_type
          trigger
          type
          value
        }
        ads_sdk
        canonical_url
        faqs {
          questions {
            faq {
              answer
              question
              title
            }
          }
          title
        }
        image_sets {
          images {
            alt
            content
            image {
              height
              url
              width
            }
          }
          name
        }
        meta {
          content
          description
          image {
            url
          }
          name
          provider
          title
          type
        }
        partner_logo {
          alt
          image {
            height
            url
            width
          }
        }
        partner_mobile_logo {
          alt
          image {
            height
            url
            width
          }
        }
        product {
          description
          id
          name
          offers {
            price {
              currency
              amount
            }
            url
          }
          product_images {
            image {
              url
            }
          }
        }
        save_headline
        section_list {
          blocks {
            alt
            cta_label
            cta_url
            description
            image {
              url
            }
          }
          name
          title
        }
        sections {
          cta_label
          cta_url
          description
          image {
            url
          }
          image_alt
          mobile_image {
            url
          }
          name
          title
        }
        stats_headline
        quotes {
          quote {
            alt
            image {
              height
              width
              url
            }
            name
            quote
            title
          }
        }
        title
        type
        url
      }
    }
  }
`;

function CMSPage() {
  const { pathname } = useLocation();
  const { data, error, loading } = useQuery(GET_PAGE, {
    variables: {
      url: pathname.substring(1),
    },
  });
  const page = data?.page;

  if (error) {
    throw new Error('An error occurred while loading this page');
  }

  if (loading) {
    return (
      <Loader />
    );
  }

  if (page?.type === PageType.About) {
    return (
      <AboutUsTemplate page={page} />
    );
  }

  return (
    <LPTemplate1 page={page} />
  );
}

export default CMSPage;
